<template>
  <b-row>
    <b-col cols="12" md="3">
      <custom-input
        v-model="innerValue.label_like"
        :name="$gettext('label')"
      />
    </b-col>
    <b-col cols="12" md="3">
      <custom-input
        v-model="innerValue.letter_type"
        :name="$gettext('letter type')"
        component="select"
        :options="letterTypes"
      />
    </b-col>
  </b-row>
</template>

<script>
import vModelMixin from '@/shared/mixins/v-model'

export default {
  mixins: [vModelMixin],
  props: {
    letterTypes: {
      type: Array,
      required: true,
    },
  },
}
</script>
